import React from "react";
import { useMutation } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { client } from "helpers/client";
import { EmailPattern } from "helpers/patterns";
import { Button, Form, InputField } from "components/form";
import { PreregisterDto, usePreregisterData } from "pages/registration/registration.service";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { setPreregisterData } = usePreregisterData();

  const navigate = useNavigate();
  const { mutate, isLoading } = useMutation((data) =>
    client<PreregisterDto>("/auth/forgetPassword", { data }).then((r) => {
      if (r.error) return Promise.reject();
      return r.response;
    })
  );

  function handleForgetPassword(data: any) {
    mutate(data, {
      onSuccess(response) {
        setPreregisterData(response!);
        navigate("/info/link-sent", { state: { actionType: "resetPassword" } });
      }
    });
  }

  return (
    <div className="forgotPassword">
      <div className="login">
        <div className="row">
          <div className="col-xl-8 col-lg-10 mx-auto">
            <div className="row">
              <div className="col-lg-6">
                <h1 className="title">
                  {t("forgot-password:forgot")}
                  <span>{t("forgot-password:password")}</span>
                </h1>
              </div>

              <Form className="col-lg-6" onSubmit={handleForgetPassword} defaultValues={{ email: "" }}>
                <InputField
                  id="email"
                  label={t("forgot-password:email")}
                  rules={{
                    required: "errors:required",
                    pattern: {
                      value: EmailPattern,
                      message: "errors:invalidFormat"
                    }
                  }}
                />
                <div className="box-password">
                  <Link className="forgot ms-auto" to="/login">
                    {t("forgot-password:remembered")}
                  </Link>
                </div>
                <Button className="btn-blue" isLoading={isLoading}>
                  {t("forgot-password:continue")}
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
